import { Box, styled } from '@lingoda/ui';
import { usePrizeIcons } from '../../hooks';
import { type Prize } from '../../types';

interface Props {
    prizes: ReadonlyArray<Prize>;
    completedActivities: number;
}

const iconPositions = [
    { left: 0, bottom: 0, zIndex: 3 },
    { left: 47, top: 0, zIndex: 2 },
    { left: 93, bottom: 0, zIndex: 1 },
];

export const ChallengeBoardPrizes = ({ prizes, completedActivities }: Props) => {
    const { lockedIcons, unlockedIcons } = usePrizeIcons(prizes);

    return (
        <Box sx={{ position: 'relative', width: 150, height: 80 }}>
            {prizes.map((prize, index) => {
                const unlocked = completedActivities >= prize.value;

                return (
                    <ImgStyled
                        key={index}
                        src={unlocked ? unlockedIcons[index] : lockedIcons[index]}
                        width={56}
                        height={56}
                        alt={prize.nounTranslation}
                        sx={{ position: 'absolute', ...iconPositions[index] }}
                    />
                );
            })}
        </Box>
    );
};

const ImgStyled = styled('img')({});
